// Stub para react-native-screens no web
import { View } from 'react-native';

export const Screen = View;
export const ScreenContainer = View;
export const NativeScreen = View;
export const NativeScreenContainer = View;
export const ScreenStack = View;
export const ScreenStackHeaderConfig = View;
export const ScreenStackHeaderCenterView = View;
export const ScreenStackHeaderLeftView = View;
export const ScreenStackHeaderRightView = View;
export const ScreenStackHeaderSearchBarView = View;
export const SearchBar = View;

export const enableScreens = () => {
  console.log('enableScreens called (web stub)');
};
export const screensEnabled = () => true;

export default {
  Screen,
  ScreenContainer,
  NativeScreen,
  NativeScreenContainer,
  ScreenStack,
  ScreenStackHeaderConfig,
  ScreenStackHeaderCenterView,
  ScreenStackHeaderLeftView,
  ScreenStackHeaderRightView,
  ScreenStackHeaderSearchBarView,
  SearchBar,
  enableScreens,
  screensEnabled,
};
